"use strict";
/// <reference lib="es2022.error" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseBulkPostAcknowledgedError = exports.DatabaseBulkBudgetError = exports.DatabaseBulkPendingError = void 0;
exports.settleDatabaseBulkReceipt = settleDatabaseBulkReceipt;
/** Carries the real admitted receipt; callers must never replay its rows. */
class DatabaseBulkPendingError extends Error {
    constructor(progress) {
        super(progress.error.message);
        this.progress = progress;
        this.name = 'DatabaseBulkPendingError';
    }
}
exports.DatabaseBulkPendingError = DatabaseBulkPendingError;
/** Raised by the existing writer before admission, permitting smaller units. */
class DatabaseBulkBudgetError extends Error {
    constructor(dimension, limit, actual) {
        super(`Database bulk ${dimension} cost ${actual} exceeds ${limit}.`);
        this.dimension = dimension;
        this.limit = limit;
        this.actual = actual;
        this.code = 'DATABASE_BULK_BUDGET_EXCEEDED';
        this.name = 'DatabaseBulkBudgetError';
    }
}
exports.DatabaseBulkBudgetError = DatabaseBulkBudgetError;
/** The mutation is already durable, even when a subsequent hook failed. */
class DatabaseBulkPostAcknowledgedError extends Error {
    constructor(progress, cause) {
        super('Database bulk post-acknowledgement work failed.');
        this.progress = progress;
        this.cause = cause;
        this.name = 'DatabaseBulkPostAcknowledgedError';
    }
}
exports.DatabaseBulkPostAcknowledgedError = DatabaseBulkPostAcknowledgedError;
/** Settle only the admitted batch. Never resume/replay its interrupted iterator. */
function settleDatabaseBulkReceipt(pending, receipt) {
    if (receipt.workspaceId !== pending.receipt.workspaceId ||
        receipt.groupId !== pending.receipt.groupId ||
        receipt.operationId !== pending.receipt.operationId)
        throw new Error('Bulk receipt identity mismatch.');
    const { error: _error, status: _status, ...previous } = pending;
    const progress = {
        ...previous,
        receipt: {
            ...pending.receipt,
            state: receipt.state,
            ...(receipt.receiptDigest
                ? { receiptDigest: receipt.receiptDigest }
                : {}),
        },
    };
    if (receipt.state === 'PENDING' || receipt.state === 'CLAIMED')
        return { ...pending, receipt: progress.receipt };
    if (receipt.state === 'COMMITTED') {
        if (!receipt.receiptDigest)
            throw new Error('Committed receipt digest is unavailable.');
        progress.confirmedCount += new Set(pending.receipt.sourceRowIds).size;
        return progress.iteratorExhausted
            ? { ...progress, status: 'completed' }
            : {
                ...progress,
                status: 'partial',
                error: {
                    code: 'RUN_INTERRUPTED_AFTER_RECEIPT',
                    message: 'Receipt committed; the interrupted source iterator has not been resumed.',
                    retryable: false,
                },
            };
    }
    return {
        ...progress,
        status: receipt.state === 'CANCELLED' ? 'cancelled' : 'partial',
        error: {
            code: receipt.state === 'CANCELLED' ? 'CANCELLED' : 'WRITE_FAILED',
            message: receipt.failureClass ??
                `Mutation receipt ${receipt.state.toLowerCase()}.`,
            retryable: false,
        },
    };
}
